module.exports = __webpack_public_path__ + "static/fullstack-20e86849339e793c406a6432148dfb56.png";